// extracted by mini-css-extract-plugin
module.exports = {"languageContainer":"_language-switcher_languageContainer__H0boq"};